module.exports = __webpack_public_path__ + "static/login/img/logo-management.de42f358.svg";